import React from "react";
import { useLocation } from 'react-router-dom';
import Header from '../Header';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Button,
  Typography
} from "@mui/material";

const PaymentSuccess = () => {
    const navigate = useNavigate();
    const getCurrentDateTimeIST = () => {
        const now = new Date();
    
        // Convert to IST (Indian Standard Time)
        const options = {
          timeZone: "Asia/Kolkata",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        };
    
        return new Intl.DateTimeFormat("en-IN", options).format(now);
    };
    
    const currentDateTime = getCurrentDateTimeIST();
    

  // Handle form submission
  
    return (
    <div className="bg-container">
        <Header />
        <Box
          sx={{
            maxWidth: 500,
            margin: "150",
            padding: 4,
            boxShadow: 3,
            borderRadius: 2,
            backgroundColor: "#f9f9f9",
          }}
        >
          <Typography variant="h4" gutterBottom align="center">
            Success
          </Typography>
          
          {/* Display Selected Biller */}
          <Typography variant="body1" sx={{ marginBottom: 2 }}>
              <strong>BBPS Transacion Id:</strong> {"PP012086D"}
          </Typography>

          {/* Display Entered Number */}
          <Typography variant="body1" sx={{ marginBottom: 2 }}>
              <strong>Date:</strong> {currentDateTime}
          </Typography>
         
          <img
            src="tick.png" // Replace with your image URL
            alt="Bill Confirmation"
            style={{
                height:"250px",                
                width: "250px", // Ensures the image fits the Box width
                borderRadius: "8px", // Optional: Adds rounded corners to the image
                marginBottom: "16px", // Adds spacing below the image
                alignContent: "center", // Aligns the image to the center
                
            }}
        />
    </Box>
    </div>
    );
};

export default PaymentSuccess;